import { format } from "date-fns"
import { SofiaAvatar } from "@/components/sofia-avatar"
import { AgentMessageContentRouter } from "@/modules/chats/components/chat-message/agent-content/agent-message-content-router"
import { PatientMessageContentRouter } from "@/modules/chats/components/chat-message/patient-content/patient-message-content-router"
import { LiveTranslationView, SofiaChatMessage } from "@/modules/chats/types/chat-message"
import { ChatPatient } from "@/modules/chats/types/chat-thread"
import { Language } from "@/types/__generated__/union-types"

type ChatMessageProps = {
  chatMessage: SofiaChatMessage
  shouldShowAvatar: boolean
  isLastMessageInGroup: boolean
  appointmentId: string
  patient: ChatPatient
  patientLanguage: Language
  liveTranslation: LiveTranslationView
}

export const ChatMessageItem = (props: ChatMessageProps) => {
  const {
    chatMessage,
    shouldShowAvatar,
    isLastMessageInGroup,
    appointmentId,
    patient,
    patientLanguage,
    liveTranslation,
  } = props
  const isPatient = chatMessage.role === "patient"

  function displayAvatar() {
    if (!shouldShowAvatar) {
      return null
    }

    if (!isLastMessageInGroup) {
      return <div className="w-6"></div>
    }

    const names = chatMessage.senderDisplayName?.split(" ")

    return <SofiaAvatar firstName={names[0]} lastName={names[1]} />
  }

  return (
    <div
      className={`animate-fade-in-bottom flex min-h-8.5 transition-all ${
        isPatient ? "flex-row" : "flex-row-reverse"
      } ${shouldShowAvatar ? "gap-2" : ""}`}>
      <div className="grid items-end">{displayAvatar()}</div>
      <div
        className={`grid-cols-1fr-auto grid h-fit max-w-166 items-end gap-1 rounded-xl px-3 py-1.5 ${isPatient ? "bg-surface-subdued text-on-surface rounded-bl" : "bg-primary text-on-primary rounded-br"}`}>
        <div className="flex h-fit items-end">
          {isPatient ? (
            <PatientMessageContentRouter
              message={chatMessage}
              appointmentId={appointmentId}
              patient={patient}
              patientLanguage={patientLanguage}
              liveTranslation={liveTranslation}
            />
          ) : (
            <AgentMessageContentRouter message={chatMessage} liveTranslation={liveTranslation} />
          )}
        </div>
        <div
          className={`flex min-h-5.5 items-end justify-end text-xs ${
            isPatient ? "text-on-surface-subdued" : "text-inherit"
          }`}>
          {format(chatMessage.sentAt, "HH:mm")}
        </div>
      </div>
    </div>
  )
}
